import { render } from "./PartnerObjects.vue?vue&type=template&id=e8c1e87e&scoped=true"
import script from "./PartnerObjects.vue?vue&type=script&lang=js"
export * from "./PartnerObjects.vue?vue&type=script&lang=js"

import "./PartnerObjects.vue?vue&type=style&index=0&id=e8c1e87e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c1e87e"]])

export default __exports__